import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Auth } from '@aws-amplify/auth';

import Page from '../pages';
import useDidMount from '../../../shared/hooks/useDidMount';
import { readRedirectedFromParam } from '../../features/authentication/helpers/functions/url';
import AuthAppIframe from '../../features/authentication/components/AuthIframe';

export default function Authentication() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  useDidMount(() => {
    (async () => {
      try {
        await Auth.currentSession();

        const redirectedFrom = readRedirectedFromParam(searchParams);
        void navigate(redirectedFrom ?? Page.notFound, { replace: true });
      } catch {
        setAuthenticated(false);
      }
    })();
  });

  return authenticated == null ? null : (
    <AuthAppIframe defaultRedirectUrl={Page.notFound} />
  );
}
